<div class="p-grid marginzero p-justify-even" style="flex-wrap: wrap;">
  <app-track-item
    *ngFor="let item of trackList"
    [trackItem]="item"
    [isSearch]="isSearch"
  >
  </app-track-item>
</div>
